import { theme } from "@shapeable/theme";
import { useThemeEval } from "./use-theme-eval";
import { useThemeMode } from "./use-theme-mode";
import { get } from "lodash";
import { isDarkColor } from "@shapeable/utils";
// returns true if the color key passed is a dark color
// this hook is context aware, in that it will check the active theme mode 
// and use the appropriate (light or dark) color for the key presented inside the given tokens.
export var useIsDarkColor = function (_a) {
  var colors = _a.colors,
    key = _a.key;
  var $ = useThemeEval();
  var mode = useThemeMode();
  var color = $(theme.COLOR(get(colors, "".concat(mode, ".").concat(key), get(colors, key))));
  return color ? isDarkColor(color) : false;
};